import { render } from "./OrderChallan.vue?vue&type=template&id=9e22ba64"
import script from "./OrderChallan.vue?vue&type=script&lang=js"
export * from "./OrderChallan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__